module.exports = __webpack_public_path__ + "media/theme/banner_cards-dc4ba7eb.png";